type Translation = {
  en: {
    [name: string]: string;
  };
  ar: {
    [name: string]: string;
  };
};

const translation = {
  en: {
    distributor: "Brands",
    new_cars: "New Cars",
    new_motorcycles: "New Motorcycles",
    new_buses: "New Buses",
    new_trucks: "New Trucks & Machinery",
    used_cars: "Used Cars",
    used_motorcycles: "Used Motorcycles",
    used_buses: "Used Buses",
    used_trucks: "Used Trucks & Machinery",
    imported_cars: "Imported Cars",
    imported_motorcycles: "Imported Motorcycles",
    imported_buses: "Imported Buses",
    imported_trucks: "Imported Trucks & Machinery",
    trucks_machinery: "Trucks & Machinery",
    showrooms: "Showrooms",
    service_centers: "Service Centers",
    servicecs: "Services",
    sell_vehicle: "Sell My Vehicle",
    compare: "Compare",
    uncompare: "Uncompare",
    tyres: "Tyres",
    news: "News",
    contact_us: "Contact Us",
    contact_us_sub_title: "We are here to help you",
    subject: "Subject",
    message: "Message",
    submit_success: "Your message has been sent successfully",
    submit_error: "An error occurred while sending your message",
    related_news: "Related News",
    language: "Languages",
    login: "Login",
    profile: "Profile",
    edit_profile: "Edit Profile",
    wishlist: "Wishlist",
    my_vehicles: "My Vehicles",
    notifications: "Notifications",
    logout: "Logout",
    looking_for: "Looking for",
    cars: "Cars",
    car: "Car",
    motorcycles: "Motorcycles",
    motorcycle: "Motorcycle",
    buses: "Buses",
    bus: "Buses",
    trucks: "Trucks & Machinery",
    truck: "Truck",
    new: "New",
    used: "Used",
    imported: "Imported",
    machinery_equipment: "Machinery & Equipment",
    new_car_offers: "New Car Offers",
    new_car_releases: "New Car Releases",
    buy_used_car: "Buy Used Car",
    buy_imported_car: "Buy Imported Car",
    model: "Model",
    year: "Year",
    starts_from: "Starts from",
    currentlyUnavailableNewVehicle: "Price Upon Request",
    free_maintenance: "Free Maintenance",
    receive_free_maintenance: "Receive free maintenance",
    cash_discount: "Cash Discount",
    view_more: "View More",
    home: "Home",
    featured_showrooms: "Featured Showrooms",
    branches: "Branches",
    find_your_brand: "Find Your Brand",
    show_more: "Show More",
    show_less: "Show Less",
    recently_added: "Recently Added",
    new_offers: "New Offers",
    class: "Class",
    classes: "Classes",
    maintenance_table: "Vehicle Brochure",
    price: "Price",
    min_deposit: "Min Deposit",
    min_installment: "Min Installment",
    contact_showroom: "Contact Showroom",
    contact_seller: "Contact Seller",
    gallery: "Gallery",
    highlights: "Highlights",
    equipment: "Equipment",
    available_colors: "Available Colors",
    similar: "Similar",
    similarVehicle: "Similar %vehicleName%",
    request: "Request Price Offer",
    place_ad_now: "Place Your Ad Now",
    sell_my_car: "Sell My Car",
    sell_my_bus: "Sell My Bus",
    sell_my_motorcycle: "Sell My Motorcycle",
    sell_my_truck: "Sell My Truck",
    class_differences: "Class Difference",
    find_a: "Find a",
    brand: "Brand",
    city: "City",
    region: "Region",
    color: "Color",
    mileage: "Mileage",
    price_range: "Price Range",
    call: "Call",
    request_call_back: "Request Call Back",
    submit: "Submit",
    reset: "Reset",
    send: "Send",
    full_name: "Full Name",
    mobile_number: "Mobile Number",
    whatsapp_note: "NOTE: If not in Egypt please provide a WhatsApp number",
    add_comment: "Add Comment",
    report_this: "Report this",
    follow_us: "Follow Us",
    about_us: "About Us",
    call_showroom: "Call Showroom",
    available_in_showrooms: "Available in Showrooms",
    call_center: "Call Service Center",
    remove_wishlist: "Remove from wishlist",
    car_sure_to_remove_wishlist: "Are you sure you want to remove this car from wishlist?",
    bus_sure_to_remove_wishlist: "Are you sure you want to remove this bus from wishlist?",
    truck_sure_to_remove_wishlist: "Are you sure you want to remove this truck from wishlist?",
    motorcycle_sure_to_remove_wishlist: "Are you sure you want to remove this motorcycle from wishlist?",
    car_sure_to_remove_compare: "Are you sure you want to remove this car from compare?",
    bus_sure_to_remove_compare: "Are you sure you want to remove this car from compare?",
    truck_sure_to_remove_compare: "Are you sure you want to remove this car from compare?",
    motorcycle_sure_to_remove_compare: "Are you sure you want to remove this car from compare?",
    remove: "Remove",
    cancel: "Cancel",
    compare_list_full: "Compare list is full for this category. Remove from the list one",
    add_to_compare: "Add to Compare",
    add_another: "Add Another",
    signin: "Sign in",
    signup: "Sign up",
    remember_me: "Remember me",
    forgot_password: "Forgot password",
    remember_password: "Remember password",
    signin_with: "Sign in with",
    facebook: "Facebook",
    google: "Google",
    whatsapp: "WhatsApp",
    phone: "Phone Number",
    email: "Email",
    optional: "Optional",
    password: "Password",
    current_password: "Current Password",
    new_password: "New Password",
    change_password: "Change Password",
    change_password_successfuly: "Password has changed successfuly! Login now.",
    name: "Name",
    confirm_password: "Confirm Password",
    enter_phone_email_account: "Enter phone number or email associated with your account",
    verification: "Verification",
    we_sent_code: "We have sent OTP to your phone.",
    didnt_receive_code: "Didn't receive SMS?",
    resend_code: "Resend Code",
    verify: "Verify",
    passwords_dont_match: "Passwords don't match",
    about_your_vehicle: "About Your Vehicle",
    personal_info: "Personal Information",
    vehicle_type: "Vehicle Type",
    add_images: "Add Images",
    add_images_note:
      "Recommended to photograph: Front Side - Back Side - Right Side - Left Side - Interior - Dashboard",
    next: "Next",
    previous: "Previous",
    preview: "Preview",
    view: "View",
    national_id: "National ID",
    license_id: "License ID",
    truck_classification: "Category",
    truck_type: "Type",
    truck_category: "Category",
    change_profile_pic: "Change profile picture",
    save_changes: "Save Changes",
    find: "Find",
    load_more: "Load More",
    error_occured: "Error occurred!",
    confirm: "Confirm",
    confirm_request: "Confirm this request?",
    fleet: "Company",
    fleet_name: "Company Name",
    fleets: "Fleets",
    individuals: "Individuals",
    position: "Position",
    cash: "Cash",
    number_of: "Number of ",
    comment: "Comment",
    requested_successfuly: "Your request was confirmed. We will contact you soon.",
    reported_successfuly: "Reported Successfuly",
    your_ad_ready: "Your ad is ready.",
    publish: "Publish",
    description: "Description",
    in_en: "in English",
    in_ar: "in Arabic",
    ad_placed_successfuly: "Ad is placed successfuly",
    removed_listing_successfuly: "Listing Has Been Removed",
    view_my_vehicle: "View to edit",
    edit_my_vehicle: "Edit vehicle",
    edit: "Edit",
    registered_successfuly: "Registered successfuly. You can login now.",
    privacy_policy: "Privacy Policy",
    terms_conditions: "Terms & Conditions",
    quick_links: "Quick Links",
    connect_w_us: "Connect With Us",
    tags: "Tags",
    working_hours: "Working Hours",
    days_off: "Days Off",
    sort_by: "Sort By",
    most_recent: "Most Recent",
    acknowledgement: "I acknowledge that all the previous data is at my own resposibility",
    min_year: "Min. Year",
    max_year: "Max. Year",
    min_price: "Min. Price",
    max_price: "Max. Price",
    copy_link: "Copy Link",
    required_field: "This field is required",
    min_amount: "Minimum amount",
    max_amount: "Maximum amount",
    min_mileage: "Min. mileage",
    max_mileage: "Max. mileage",
    show: "Show",
    hide: "Hide",
    add_your_car: "Add your %vehicles%",
    no_sold: "It seems you don't have sold %vehicles%",
    no_wishlist: "It seems you don't have %vehicles% in your wishlist",
    no_compare: "It seems you don't have %vehicles% in your compare list",
    sure_to_delete: "Are you sure you want to delete this?",
    edit_phone: "Edit phone number",
    updated_successfuly: "Updated successfuly",
    update: "Update",
    companies: "Companies",
    our_team: "Our team",
    addedToCompare: "Added to compare list",
    rentable: "Rentable",
    rent: "Rent",
    month: "Month",
    max_chars: "Maximum number is %NUM% characters",
    no_attributes: "No features for the selected brand or category found",
    visitUsHere: "Maps Location",
    workHours: "Working Hours",
    location: "Location",
    daysOff: "Days Off",
    hours: "Hours",
    addedToWishlistSuccess: "Added to your Wishlist",
    removedFromWishlistSuccess: "Removed from your Wishlist",
    chooseTruckCategory: "Choose Truck Category",
    noResult: "No Result Found",
    selectInputSelect: "Select...",
    selectInputSelectOption: "Select option",
    egp: "EGP",
    km: "km",
    max10Images: "You can only upload 10 images",
    questionMark: "?",
    a: "",
    romotors: "Romotors",
    sponsared: "Sponsored",
    callForPrice: "Call For Price",
    light_trucks: "Light Trucks",
    heavy_trucks: "Heavy Trucks",
    trailers: "Trailers",
    machinery: "Machinery",
    handling_equipment: "Handling Equipment",
    light_trucks_sure_to_remove_compare: "Are you sure you want to remove this light truck from compare list?",
    heavy_trucks_sure_to_remove_compare: "Are you sure you want to remove this heavy truck from compare list?",
    trailers_sure_to_remove_compare: "Are you sure you want to remove this trailer from compare list?",
    machinery_sure_to_remove_compare: "Are you sure you want to remove this machinery from compare list?",
    handling_equipment_sure_to_remove_compare:
      "Are you sure you want to remove this handling equipment from compare list?",
    new_light_trucks: "New Light Trucks",
    new_heavy_trucks: "New Heavy Trucks",
    new_trailers: "New Trailers",
    new_machinery: "New Machinery",
    new_handling_equipment: "New Handling Equipment",
    used_light_trucks: "Used Light Trucks",
    used_heavy_trucks: "Used Heavy Trucks",
    imported_light_trucks: "Imported Light Trucks",
    imported_heavy_trucks: "Imported Heavy Trucks",
    used_trailers: "Used Trailers",
    imported_trailers: "Imported Trailers",
    imported_machinery: "Imported Machinery",
    imported_handling_equipment: "Imported Handling Equipment",
    used_machinery: "Used Machinery",
    used_handling_equipment: "Used Handling Equipment",
    sell_my_light_trucks: "Sell My Light Truck",
    sell_my_heavy_trucks: "Sell My Heavy Truck",
    sell_my_trailers: "Sell My Trailer",
    sell_my_machinery: "Sell My Machinery",
    sell_my_handling_equipment: "Sell My Handling Equipment",
    light_trucks_sure_to_remove_wishlist: "Are you sure you want to remove this light truck from wishlist?",
    heavy_trucks_sure_to_remove_wishlist: "Are you sure you want to remove this heavy truck from wishlist?",
    trailers_sure_to_remove_wishlist: "Are you sure you want to remove this trailer from wishlist?",
    machinery_sure_to_remove_wishlist: "Are you sure you want to remove this machinery from wishlist?",
    handling_equipment_sure_to_remove_wishlist:
      "Are you sure you want to remove this handling equipment from wishlist?",
    chooseVehicleCategory: "Choose Vehicle Category",
    new_bus_offers: "Recent Bus Offers",
    new_bus_releases: "New Bus Releases",
    buy_used_bus: "Buy Used Bus",
    buy_imported_bus: "Buy Imported Bus",
    vehiclesSearch: "Vehicles Search",
    installment: "Financing",
  } as const,
  ar: {
    installment: "تمويل",
    vehiclesSearch: "بحث",
    buy_imported_bus: "شراء سيارة استيراد",
    buy_used_bus: "شراء سيارة استعمال",
    new_bus_offers: "باصات معروضة حديثا",
    new_bus_releases: "باصات جديدة",
    chooseVehicleCategory: "اختر فئة الماكينة",
    sell_my_heavy_trucks: "أضف إعلانك الآن",
    sell_my_trailers: "أضف إعلانك الآن",
    sell_my_machinery: "أضف إعلانك الآن",
    sell_my_handling_equipment: "أضف إعلانك الآن",
    sell_my_light_trucks: "أضف إعلانك الآن",
    light_trucks_sure_to_remove_wishlist: "هل أنت متأكد من حذف هذه الشاحنة من قائمة المفضلة؟",
    heavy_trucks_sure_to_remove_wishlist: "هل أنت متأكد من حذف هذه الشاحنة من قائمة المفضلة؟",
    trailers_sure_to_remove_wishlist: "هل أنت متأكد من الحذف من قائمة المفضلة؟",
    machinery_sure_to_remove_wishlist: "هل أنت متأكد من حذف هذه المعدة من قائمة المفضلة؟",
    handling_equipment_sure_to_remove_wishlist: "هل أنت متأكد من حذف هذه المعدة من قائمة المفضلة؟",
    used_handling_equipment: "معدات رفع مستعملة",
    imported_handling_equipment: "معدات رفع إستيراد",
    used_machinery: "معدات ثقيلة مستعملة",
    imported_machinery: "معدات ثقيلة إستيراد",
    imported_trailers: "ديول إستيراد",
    used_trailers: "ديول و مقطورات مستعملة",
    imported_heavy_trucks: "شاحنات ثقيلة إستيراد",
    imported_light_trucks: "شاحنات خفيفة إستيراد",
    used_heavy_trucks: "شاحنات ثقيلة مستعملة",
    used_light_trucks: "شاحنات خفيفة مستعملة",
    new_light_trucks: "شاحنات خفيفة جديدة",
    new_heavy_trucks: "شاحنات ثقيلة جديدة",
    new_trailers: "ديول جديدة",
    new_machinery: "معدات جديدة",
    new_handling_equipment: "معدات رفع جديدة",
    light_trucks_sure_to_remove_compare: "هل أنت متأكد من حذف هذه الشاحنة من قائمة المقارنة؟",
    heavy_trucks_sure_to_remove_compare: "هل أنت متأكد من حذف هذه الشاحنة من قائمة المقارنة؟",
    trailers_sure_to_remove_compare: "هل أنت متأكد من الحذف من قائمة المقارنة؟",
    machinery_sure_to_remove_compare: "هل أنت متأكد من حذف هذه المعدة من قائمة المقارنة؟",
    handling_equipment_sure_to_remove_compare: "هل أنت متأكد من حذف هذه المعدة من قائمة المقارنة؟",
    machinery: "معدات الحفر و البناء",
    handling_equipment: "معدات الرفع و المناولة",
    trailers: "ديول و مقطورات",
    heavy_trucks: "النقل الثقيل",
    light_trucks: "النقل المتوسط",
    callForPrice: "اتصل بالبائع",
    sponsared: "ممول",
    distributor: "الوكلاء",
    romotors: "ماكينات",
    a: "",
    questionMark: "؟",
    max10Images: "يمكنك تحميل 10 صور فقط",
    km: "كم",
    egp: "جنيه",
    selectInputSelectOption: "اختر",
    selectInputSelect: "اختر...",
    noResult: "لم يتم العثور على نتائج",
    chooseTruckCategory: "اختر فئة الشاحنة",
    new_cars: "سيارات جديدة",
    //new_motorcycles: "دراجات جديدة",
    new_motorcycles: "جديد",
    //new_buses: "حافلات جديدة",
    new_buses: "جديد",
    //new_trucks: "شاحنات و معدات جديدة",
    new_trucks: "جديد",
    used_cars: "سيارات مستعملة",
    //used_motorcycles: "دراجات مستعملة",
    used_motorcycles: "مستعمل",
    //used_buses: "حافلات مستعملة",
    used_buses: "مستعمل",
    //used_trucks: "شاحنات و معدات مستعملة",
    used_trucks: "مستعمل",
    imported_cars: "سيارات استيراد",
    //imported_motorcycles: "دراجات استيراد",
    imported_motorcycles: "استيراد",
    //imported_buses: "حافلات استيراد",
    imported_buses: "استيراد",
    //imported_trucks: "شاحنات و معدات استيراد",
    imported_trucks: "استيراد",
    trucks_machinery: "شاحنات و معدات",
    showrooms: "معارض",
    service_centers: "مراكز الصيانة",
    servicecs: "الخدمات",
    sell_vehicle: "بيع ماكينتي",
    compare: "مقارنة",
    uncompare: "حذف من المقارنة",
    tyres: "اطارات",
    news: "أخبار",
    contact_us: "تواصل معنا",
    contact_us_sub_title: "نحن هنا لمساعدتك",
    subject: "الموضوع",
    message: "الرسالة",
    submit_success: "تم ارسال الرسالة بنجاح",
    submit_error: "حدث خطأ اثناء ارسال الرسالة",
    related_news: "أخبار متعلقة",
    language: "اللغة",
    login: "تسجيل الدخول",
    profile: "الصفحة الشخصية",
    edit_profile: "تعديل بياناتي",
    wishlist: "مفضلات",
    my_vehicles: "اعلاناتي",
    notifications: "اشعارات",
    logout: "تسجيل الخروج",
    looking_for: "تبحث عن",
    cars: "سيارات",
    car: "سيارة",
    //motorcycles: "دراجات نارية",
    motorcycles: "موتوسيكلات",
    motorcycle: "موتوسيكل",
    buses: "باصات",
    bus: "باصات",
    trucks: "شاحنات و معدات",
    truck: "شاحنة",
    new: "جديد",
    used: "مستعمل",
    imported: "استيراد",
    machinery_equipment: "آلات و معدات",
    new_car_offers: "عروض السيارات جديدة",
    new_car_releases: "أحدث السيارات الجديدة",
    buy_used_car: "اشترى سيارة مستعملة",
    buy_imported_car: "اشترى سيارة استيراد",
    model: "موديل",
    year: "سنة",
    starts_from: "تبدأ من",
    currentlyUnavailableNewVehicle: "السعر عند الطلب",
    free_maintenance: "صيانة مجانية",
    receive_free_maintenance: "احصل على صيانة مجانية",
    cash_discount: "خصم نقدى",
    view_more: "عرض المزيد",
    home: "الرئيسية",
    featured_showrooms: "المعارض المميزة",
    branches: "الفروع",
    find_your_brand: "ابحث عن ماركتك",
    show_more: "عرض المزيد",
    show_less: "عرض أقل",
    recently_added: "أحدث الاضافات",
    new_offers: "عروض جديدة",
    class: "صنف",
    classes: "تصنيفات",
    maintenance_table: "كتيب المواصفات",
    price: "السعر",
    min_deposit: "أقل مقدم",
    min_installment: "أقل قسط",
    contact_showroom: "تواصل مع المعرض",
    contact_seller: "تواصل مع البائع",
    gallery: "الصور",
    highlights: "المواصفات الرئيسية",
    equipment: "التجهيزات",
    available_colors: "الألوان المتاحة",
    similar: "مشابهة",
    similarVehicle: "%vehicleName% مشابهة",
    request: "طلب عرض سعر",
    place_ad_now: "لديك ماكينة للبيع؟",
    sell_my_car: "عرض سيارتى للبيع",
    sell_my_bus: "عرض حافلتى للبيع",
    sell_my_motorcycle: "عرض دراجتى للبيع",
    sell_my_truck: "عرض شاحنتى للبيع",
    class_differences: "فرق الصنف السابق",
    find_a: "البحث عن",
    brand: "الماركة",
    city: "المدينة",
    region: "المنطقة",
    color: "اللون",
    mileage: "العداد",
    price_range: "نطاق السعر",
    call: "الاتصال",
    request_call_back: "طلب الاتصال بك",
    submit: "إرسال",
    reset: "مسح الكل",
    send: "ارسال",
    full_name: "الاسم بالكامل",
    mobile_number: "رقم الموبايل",
    whatsapp_note: "تنويه: فى حالة رقم موبايل دولى برجاء ادخال رقم موبايل للواتساب",
    add_comment: "اضف تعليق",
    report_this: "الابلاغ عن",
    follow_us: "تابعنا",
    about_us: "نبذة مختصرة",
    call_showroom: "تواصل مع المعرض",
    available_in_showrooms: "معارض متاح لديها",
    call_center: "تواصل مع المركز",
    remove_wishlist: "حذف من المفضلات",
    car_sure_to_remove_wishlist: "هل أنت متأكد من حذف السيارة من المفضلات؟",
    bus_sure_to_remove_wishlist: "هل أنت متأكد من حذف الحافلة من المفضلات؟",
    truck_sure_to_remove_wishlist: "هل أنت متأكد من حذف الشاخنة من المفضلات؟",
    motorcycle_sure_to_remove_wishlist: "هل أنت متأكد من حذف الدراجة من المفضلات؟",
    car_sure_to_remove_compare: "هل أنت متأكد من حذف السيارة من المقارنات؟",
    bus_sure_to_remove_compare: "هل أنت متأكد من حذف السيارة من المقارنات؟",
    truck_sure_to_remove_compare: "هل أنت متأكد من حذف السيارة من المقارنات؟",
    motorcycle_sure_to_remove_compare: "هل أنت متأكد من حذف السيارة من المقارنات؟",
    remove: "حذف",
    cancel: "اغلاق",
    compare_list_full: "قائمة المقارنات ممتلئة لهذه المجموعة. برجاء حذف من القائمة",
    add_to_compare: "اضف لقائمة المقارنة",
    add_another: "اضف",
    signin: "تسجيل الدخول",
    signup: "تسجيل",
    remember_me: "تذكرنى",
    forgot_password: "نسيت كلمة المرور",
    remember_password: "تذكرت كلمة المرور",
    signin_with: "تسجيل الدخول عبر",
    facebook: "فيسبوك",
    google: "جوجل",
    whatsapp: "واتساب",
    phone: "رقم الهاتف",
    email: "البريد الالكترونى",
    optional: "اختيارى",
    password: "كلمة المرور",
    current_password: "كلمة المرور الحالية",
    new_password: "كلمة المرور الجديدة",
    change_password: "تغيير كلمة المرور",
    change_password_successfuly: "تم تغيير كلمة المرور بنجاح! سجل الدخول الآن.",
    name: "الاسم",
    confirm_password: "تأكيد كلمة المرور",
    enter_phone_email_account: "أدخل رقم الهاتف أو البريد الاكترونى الخاص بحسابك",
    verification: "تأكيد الهوية",
    we_sent_code: "لقد أرسلنا الكود إلى هاتفك.",
    didnt_receive_code: "لم تستقبل الكود؟",
    resend_code: "ارسال كود آخر",
    verify: "تأكيد",
    passwords_dont_match: "كلمات السر غير متوافقة",
    about_your_vehicle: "تفاصيل الماكينة",
    personal_info: "تفاصيل شخصية",
    vehicle_type: "نوع الماكينة",
    add_images: "اضف صور",
    add_images_note:
      "المرشح للتصوير: الجانب الامامى - الجانب الخلفى - الجانب الايمن - الجانب الايسر - من الداخل - قمرة القيادة",
    next: "التالى",
    previous: "السابق",
    preview: "معاينة",
    view: "عرض",
    national_id: "الرقم القومى",
    license_id: "رقم الرخصة",
    truck_classification: "التصنيف",
    truck_type: "الهيكل",
    truck_category: "التصنيف",
    change_profile_pic: "تغيير الصورة الشخصية",
    save_changes: "حفظ التغييرات",
    find: "بحث",
    load_more: "اظهار المزيد",
    error_occured: "حدث خطأ!",
    confirm: "تأكيد",
    confirm_request: "تأكيد الطلب؟",
    fleet: "شركة",
    fleets: "شركات",
    individuals: "أفراد",
    fleet_name: "اسم الشركة",
    position: "المركز",
    cash: "نقدى",
    number_of: "العدد المطلوب",
    comment: "تعليق",
    requested_successfuly: "تم تسجيل الطلب بنجاح و سيتم التواصل معكم",
    reported_successfuly: "تم الابلاغ بنجاح",
    your_ad_ready: "اعلانك جاهز.",
    publish: "اعلن الآن",
    in_en: "بالإنجليزية",
    description: "الوصف",
    in_ar: "بالعربية",
    ad_placed_successfuly: "تم إضافة الاعلان بنجاح",
    view_my_vehicle: "عرض للتعديل",
    edit_my_vehicle: "تعديل الإعلان",
    edit: "تعديل",
    registered_successfuly: "تم التسجيل بنجاح. يمكنك تسجيل الدخول الآن",
    privacy_policy: "سياسة الخصوصية",
    terms_conditions: "الشروط و الأحكام",
    quick_links: "روابط سريعة",
    connect_w_us: "تواصل معنا",
    tags: "الروابط",
    working_hours: "مواعيد العمل",
    days_off: "أيام الاجازات",
    sort_by: "ترتيب حسب",
    most_recent: "المضاف مؤخرا",
    acknowledgement: "أقر بأن كل البيانات السابقة على مسئوليتى الشخصية",
    min_year: "أقل سنة",
    max_year: "أقصي سنة",
    min_price: "أقل سعر",
    max_price: "أقصي سعر",
    copy_link: "نسخ الرابط",
    required_field: "هذا الحقل مطلوب",
    min_amount: "الحد الأدنى",
    max_amount: "الحد الاقصى",
    min_mileage: "أقل عداد",
    max_mileage: "أقصي عداد",
    show: "عرض",
    hide: "اخفاء",
    add_your_car: "اضافة %vehicles%",
    no_sold: "لا يوجد %vehicles% لديك معروضة للبيع",
    no_wishlist: "لا يوجد %vehicles% لديك فى المفضلات",
    no_compare: "لا يوجد %vehicles% لديك فى المقارنات",
    sure_to_delete: "هل أنت متأكد من الحذف؟",
    edit_phone: "تعديل رقم الهاتف",
    updated_successfuly: "تم التعديل بنجاح",
    update: "تعديل",
    companies: "الشركة",
    our_team: "فريق العمل",
    addedToCompare: "تم الاضافة لقائمة المقارنة",
    rentable: "قابل للإيجار",
    rent: "سعر الإيجار",
    month: "شهر",
    max_chars: "الحد الأقصى للحروف %NUM% حرف",
    no_attributes: "لا يوجد كماليات للاختيار",
    visitUsHere: "موقعنا هنا",
    workHours: "مواعيد العمل",
    location: "العنوان",
    daysOff: "ايام الاجازات",
    hours: "الساعات",
    removed_listing_successfuly: "تم مسح الاعلان",
    addedToWishlistSuccess: "تمت الإضافة إلى قائمة الرغبات",
    removedFromWishlistSuccess: "تمت الإزالة من قائمة الرغبات",
  } as const,
} as const;

export default translation;
